/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {EmployeeCard} from '../../../_metronic/partials/content/cards/EmployeeCard'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {Link} from 'react-router-dom'
import {Spinner} from 'react-bootstrap'
import api from '../RequestConfig'
import 'react-toastify/dist/ReactToastify.css'
import {showToast} from '../common/toastify/toastify.config'
import ReactPaginate from 'react-paginate'

const permissionsBreadCrumbs: Array<PageLink> = [
  {
    title: 'employee_management',
    path: '/employee_management',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

interface Employee {
  appUserId: string
  isDisabled: boolean
  // Other properties of an employee
}

const API_URL = process.env.REACT_APP_API_URL
export const GET_ALL_USERS = `${API_URL}/agent/account/get-agents`
export const DELETE_SINGLE_USER = `${API_URL}/agent/account/delete-agent`
export const GET_ALL_DESIGNATIONS = `${API_URL}/agent/fields/designation/get-designation`
export const GET_ALL_DEPARTMENTS = `${API_URL}/agent/fields/department/get-department`
function CompanyEmployees() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [search, setSearch] = useState('')
  const [employees, setEmployees] = React.useState<Employee[]>([])

  const [isLoading, setIsLoading] = React.useState(false)
  const [appDesignationId, setAppDesignationId] = React.useState<string | null>(null)
  const [appDepartmentId, setAppDepartmentId] = React.useState<string | null>(null)
  const [designations, setDesignations] = React.useState([])
  const [departments, setDepartments] = React.useState([])
  const [totalRecords, setTotalRecords] = React.useState(0)
  const [isAccountDisabled, setIsAccountDisabled] = React.useState<boolean>(false)

  const accountOptions = [
    {label: 'Active Users', value: false},
    {label: 'Deactivated Users', value: true},
  ]

  // Defining variables for the pagination part
  const [currentPage, setCurrentPage] = useState(1)
  const [recordsPerPage, setRecordsPerPage] = useState(10)
  const lastIndex = currentPage * recordsPerPage
  const firstIndex = lastIndex - recordsPerPage
  useEffect(() => {
    ;(async () => {
      await load_Designations()
      await load_Departments()
    })()
  }, [])

  function handleSearch(searchValue: string) {
    setSearch(searchValue)
  }

  useEffect(() => {
    ;(async () => {
      setIsLoading(true)
      await Load()
      setIsLoading(false)
    })()
    // eslint-disable-next-line
  }, [appDesignationId, appDepartmentId, currentPage, search, recordsPerPage, isAccountDisabled])

  async function Load(parameter?: any) {
    try {
      const varToken = localStorage.getItem('token')
      const result = await api.post(
        GET_ALL_USERS,
        {
          appDesignationId: appDesignationId,
          appDepartmentId: appDepartmentId,
          search: search ? search : null,
          isDisabled: isAccountDisabled,
          metaData: {
            sortBy: null,
            sortOn: null,
            limit: recordsPerPage,
            offset: search ? null : recordsPerPage * (currentPage - 1),
          },
        },
        {
          headers: {
            genie_access_token: 'Bearer ' + varToken,
          },
        }
      )

      if (result.data.error === false) {
        setEmployees(result.data.data.AppUsers)
        setTotalRecords(result.data.data.metaData.total_records)
      }
    } catch (error) {
      console.error(error)
    }
  }
  async function DeleteSingleUser(id: any) {
    const varToken = localStorage.getItem('token')
    try {
      const result = await api.post(
        DELETE_SINGLE_USER,
        {
          appUserId: id,
        },
        {
          headers: {
            genie_access_token: 'Bearer ' + varToken,
          },
        }
      )
      if (result.data.error === false) {
        showToast(result.data.data.message, 'success')
      } else {
        showToast(`Delete Employee Failed, ${result.data.error.message}`, 'error')
      }
      await Load()
    } catch (error) {
      console.error('Error in DeleteSingleUser = ', error)
    }
  }

  async function load_Designations() {
    const varToken = localStorage.getItem('token')
    try {
      const result = await api.post(
        GET_ALL_DESIGNATIONS,
        {
          search: null,
          metaData: {
            limit: 0,
          },
        },
        {
          headers: {
            genie_access_token: 'Bearer ' + varToken,
          },
        }
      )
      setDesignations(result.data.data.appDesignations)
    } catch (err) {
      console.error(err)
    }
  }
  async function load_Departments() {
    const varToken = localStorage.getItem('token')
    try {
      const result = await api.post(
        GET_ALL_DEPARTMENTS,
        {
          search: null,
          metaData: {
            limit: 0,
          },
        },
        {
          headers: {
            genie_access_token: 'Bearer ' + varToken,
          },
        }
      )
      setDepartments(result.data.data.AppDepartment)
    } catch (err) {
      console.error(err)
    }
  }

  // Employee Card Function
  const employeeCards = employees.map((employee: any, index: number) => {
    return (
      <div key={index} className='col-md-6 col-xxl-3'>
        <EmployeeCard
          avatar='/media/avatars/300-25.jpg'
          name={employee.first_name + ' ' + employee.last_name}
          employeeType={employee.employee_type}
          id={employee.appUserId}
          DeleteSingleUser={DeleteSingleUser}
          isDisabled={employee.isDisabled}
          reloadEmployees={Load}
        />
      </div>
    )
  })

  // Style for dropdown
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }
  const dropdownStyle: any = {
    display: 'inline-block',
    position: 'relative',
    zIndex: '1',
  }
  const buttonStyle = {
    padding: '0.5rem 1rem',
    fontSize: '14px',
    lineHeight: '1.5',
  }

  const menuStyle: any = {
    display: isMenuOpen ? 'block' : 'none',
    minWidth: 'auto',
    padding: '0',
    position: 'absolute',
    top: '100%',
    right: '0',
    zIndex: '2',
  }

  // Defining functions for pagination
  const changeCurrentPage = (n: any = true) => {
    setCurrentPage(n.selected + 1)
  }

  return (
    <>
      <PageTitle breadcrumbs={permissionsBreadCrumbs}>Company Employees</PageTitle>
      <div className='d-flex   flex-wrap flex-stack mb-6'>
        {/* Showing the number of employees on page */}

        <div style={{display: 'grid'}}>
          <div className='d-flex justify-content-start fs-6 fw-bold text-gray-700'>
            Showing {firstIndex + 1} to {lastIndex <= totalRecords ? lastIndex : totalRecords} of{' '}
            {totalRecords} Employees
          </div>
          {/* Dropdown menu to display records */}
          <div className='d-flex'>
            <select
              className='form-select form-select-solid mx-2'
              style={{width: '150px', marginTop: '10px', backgroundColor: '#ececec'}}
              data-kt-select2='true'
              data-placeholder='Show records'
              value={recordsPerPage}
              onChange={(e: any) => {
                setRecordsPerPage(e.target.value)
              }}
            >
              <option value={10}>10 Records</option>
              <option value={15}>15 Records</option>
              <option value={25}>25 Records</option>
              <option value={50}>50 Records</option>
            </select>
            {/* Dropdown menu for Enable/Disable */}
            <select
              className='form-select form-select-solid mx'
              style={{width: '180px', marginTop: '10px', backgroundColor: '#ececec'}}
              onChange={(e: any) => {
                e.target.value === 'false'
                  ? setIsAccountDisabled(false)
                  : setIsAccountDisabled(true)
              }}
            >
              {accountOptions?.map((opt: any, index: number) => (
                <option value={opt.value} key={index}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        {/* Dropdown menu for filter */}
        <div className='d-flex justify-content-start flex-wrap flex-stack mb-6'>
          <div style={{display: 'flex'}}>
            <div style={dropdownStyle}>
              <button
                style={buttonStyle}
                className='btn btn-light-primary me-3'
                data-toggle='dropdown'
                onClick={toggleMenu}
              >
                <i className='fs-5 pe-2 fa-solid fa-filter'></i>Filter
              </button>
              {isMenuOpen && (
                <div
                  style={menuStyle}
                  className='menu menu-sub menu-sub-dropdown w-250px w-md-300px'
                  data-kt-menu='true'
                >
                  <div className='px-7 py-5'>
                    <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                  </div>
                  <div className='separator border-gray-200'></div>
                  <div className='px-7 py-5'>
                    <div className='form-label fw-bold'>Search Employees:</div>
                    <div className='py-3'>
                      <div className='form-group'>
                        <input
                          type='text'
                          value={search}
                          className='form-control form-control-solid fw-bold ps-10'
                          placeholder='Search Employees'
                          onChange={(e: any) => {
                            handleSearch(e.target.value)
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='px-7 py-5'>
                    <div className='mb-10'>
                      <label className='form-label fw-bold'>Filter Employees By Department:</label>

                      <div>
                        <select
                          id='selectDepartment'
                          className='form-select form-select-solid'
                          data-kt-select2='true'
                          data-placeholder='Select option'
                          data-allow-clear='true'
                          onChange={(e) => {
                            setAppDepartmentId(e.target.value !== 'null' ? e.target.value : null)
                          }}
                        >
                          <option value={'null'}>Filter by Department</option>
                          {departments.map((dn: any) => (
                            <option key={dn.appDepartmentId} value={dn.appDepartmentId}>
                              {dn.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className='mb-10'>
                      <label className='form-label fw-bold'>Filter Employees By Designation:</label>

                      <div>
                        <select
                          id='selectDesignation'
                          className='form-select form-select-solid'
                          data-kt-select2='true'
                          data-placeholder='Select option'
                          data-allow-clear='true'
                          onChange={(e) => {
                            setAppDesignationId(e.target.value !== 'null' ? e.target.value : null)
                          }}
                        >
                          <option value={'null'}>Filter by Designation</option>
                          {designations.map((dn: any) => (
                            <option key={dn.appDesignationId} value={dn.appDesignationId}>
                              {dn.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className='d-flex justify-content-end'>
                      <button
                        type='reset'
                        className='btn btn-light btn-active-light-primary me-2'
                        data-kt-menu-dismiss='true'
                        onClick={() => {
                          setAppDepartmentId(null)
                          setAppDesignationId(null)
                          setSearch('')
                          const departmentSelector = document.getElementById(
                            'selectDepartment'
                          ) as HTMLInputElement | null
                          const designationSelector = document.getElementById(
                            'selectDesignation'
                          ) as HTMLInputElement | null
                          if (departmentSelector) departmentSelector.value = 'null'
                          if (designationSelector) designationSelector.value = 'null'
                        }}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Create New Genie Button */}

            <Link
              style={{marginLeft: '10px'}}
              to={'/employee_management/create-employee'}
              className='btn btn-primary btn-sm'
              data-bs-toggle='tooltip'
            >
              Create a new Genie
            </Link>
          </div>
        </div>
      </div>
      {isLoading ? (
        <div className='d-flex align-items-center justify-content-center loader-container'>
          <Spinner animation='border' variant='primary' />
        </div>
      ) : (
        <>
          {employees.length !== 0 ? (
            <>
              <div className='row g-6 g-xl-9'>{employeeCards}</div>

              <div className='d-flex flex-stack flex-wrap pt-10'>
                {/* <div className='fs-6 fw-bold text-gray-700'></div> */}
              </div>
            </>
          ) : (
            <div className='d-flex align-items-center justify-content-center loader-container'>
              <h1>No Employees Found</h1>
            </div>
          )}
        </>
      )}
      {/* Pagination Component */}
      <ReactPaginate
        previousLabel={'<'}
        nextLabel={'>'}
        breakLabel={'...'}
        pageCount={Math.ceil(totalRecords / recordsPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={changeCurrentPage}
        containerClassName={'pagination justify-content-end'}
        pageClassName={'page-item'}
        pageLinkClassName={'page-link'}
        previousClassName={'page-item'}
        previousLinkClassName={'page-link'}
        nextClassName={'page-item'}
        nextLinkClassName={'page-link'}
        breakClassName={'page-item'}
        breakLinkClassName={'page-link'}
        activeClassName={'active'}
      />
    </>
  )
}

export default CompanyEmployees
